import React, { useRef } from "react";
import Container from "../../components/layout/Container/Container";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";
import uploadImg from "../../assets/eservice-img-upload.png";

interface UploadFormProps {
  onFilesUpload: (files: FileList) => void;
}

const UploadForm: React.FC<UploadFormProps> = ({ onFilesUpload }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleUploadButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
      fileInputRef.current.value = "";
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      onFilesUpload(files);
    }
    event.target.files = null;
  };

  return (
    <>
      {/* <Header /> */}
      {/* <Container> */}
      <div className="inner-content pt-5 pb-5">
        <div className="container mt-5 mb-5">
          <div className="landing-page tag-list">
            {/* <figure>
              <img src={uploadImg} alt="" className="img-fluid" />
            </figure> */}
            <p>Kindly re-upload the filled-up form</p>

            <button
              type="button"
              className="btn btn-success mt-4"
              onClick={handleUploadButtonClick}
            >
              Upload Form
            </button>
            <input
              type="file"
              ref={fileInputRef}
              className="csp-display-none"
              onChange={handleFileChange}
              multiple
            />
          </div>
        </div>
      </div>
      {/* </Container> */}
      {/* <Footer /> */}
    </>
  );
};

export default UploadForm;
